import { render } from "./ServiceQuarantineDurationsSettings.vue?vue&type=template&id=94b87a1e&scoped=true"
import script from "./ServiceQuarantineDurationsSettings.vue?vue&type=script&lang=js"
export * from "./ServiceQuarantineDurationsSettings.vue?vue&type=script&lang=js"

import "./ServiceQuarantineDurationsSettings.vue?vue&type=style&index=0&id=94b87a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b87a1e"]])

export default __exports__